import pendoConfig from "./pendo.config.json";

const initialize = async (pendo, user, domain) => {
  const fullNameArray = (user.display_name ?? user.name ?? "").split(" ");

  const values = {
    apiKey: "75776bd3-80af-4e74-618f-5e7a31182fc4",
    config: pendoConfig,
    env: process.env.PENDO_ENVIRONMENT,
    globalKey: "pendo",
    account: {
      id: domain?.id,
      accountName: domain?.domain_key,
    },
    visitor: {
      id: user?.email,
      email: user?.email,
      application: "permiso",
      environment: process.env.NODE_ENV,
      firstName: fullNameArray[0],
      lastName: fullNameArray[fullNameArray.length - 1],
      version: process.env.VERSION,
      platform: "web",
    },
  };

  return await pendo.initialize(values);
};

export default initialize;
